import script from "./BlackList.vue?vue&type=script&setup=true&lang=js"
export * from "./BlackList.vue?vue&type=script&setup=true&lang=js"

import "./BlackList.vue?vue&type=style&index=0&id=4ecc8351&lang=less&scoped=true"
import "./BlackList.vue?vue&type=style&index=1&id=4ecc8351&lang=less"

import exportComponent from "/home/opt/gitlab-runner/web_influencer_admin_repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4ecc8351"]])

export default __exports__